<script>
import MyCustomComp from '../src/components/MyCustomComp.vue';
export default {
  name: 'Normal4e0148ec',
  components: {
    MyCustomComp: MyCustomComp
  },
  frontmatter: JSON.parse('{"componentName":"Normal4e0148ec"}')
};
</script>

<template>
  <div>
    <h2 style="color: DarkViolet;">Normal Markdown</h2>
<p>Check out the demo below:</p>
<p>frontmatter: {{ $options.frontmatter }}</p>
<h1 style="color: DarkViolet;">h1 Heading 8-)</h1>
<h2 style="color: DarkViolet;">h2 Heading</h2>
<h3 style="color: DarkViolet;">h3 Heading</h3>
<h4 style="color: DarkViolet;">h4 Heading</h4>
<h5 style="color: DarkViolet;">h5 Heading</h5>
<h6 style="color: DarkViolet;">h6 Heading</h6>
<h2 style="color: DarkViolet;">Horizontal Rules</h2>
<hr>
<hr>
<hr>
<h2 style="color: DarkViolet;">Typographic replacements</h2>
<p>Enable typographer option to see result.</p>
<p>(c) (C) (r) (R) (tm) (TM) (p) (P) +-</p>
<p>test.. test... test..... test?..... test!....</p>
<p>!!!!!! ???? ,,  -- ---</p>
<p>"Smartypants, double quotes" and 'single quotes'</p>
<h2 style="color: DarkViolet;">Emphasis</h2>
<p><strong>This is bold text</strong></p>
<p><strong>This is bold text</strong></p>
<p><em>This is italic text</em></p>
<p><em>This is italic text</em></p>
<p><del>Strikethrough</del></p>
<h2 style="color: DarkViolet;">Blockquotes</h2>
<blockquote>
<p>Blockquotes can also be nested...</p>
<blockquote>
<p>...by using additional greater-than signs right next to each other...</p>
<blockquote>
<p>...or with spaces between arrows.</p>
</blockquote>
</blockquote>
</blockquote>
<h2 style="color: DarkViolet;">Lists</h2>
<p>Unordered</p>
<ul>
<li>Create a list by starting a line with <code>+</code>, <code>-</code>, or <code>*</code></li>
<li>Sub-lists are made by indenting 2 spaces:<ul>
<li>Marker character change forces new list start:<ul>
<li>Ac tristique libero volutpat at</li>
</ul><ul>
<li>Facilisis in pretium nisl aliquet</li>
</ul><ul>
<li>Nulla volutpat aliquam velit</li>
</ul></li>
</ul></li>
<li>Very easy!</li>
</ul>
<p>Ordered</p>
<ol>
<li>Lorem ipsum dolor sit amet</li>
<li>Consectetur adipiscing elit</li>
<li>Integer molestie lorem at massa</li>
</ol>
<ol start="4">
<li>You can use sequential numbers...</li>
<li>...or keep all the numbers as <code>1.</code></li>
</ol>
<p>Start numbering with offset:</p>
<ol start="57">
<li>foo</li>
<li>bar</li>
</ol>
<h2 style="color: DarkViolet;">Code</h2>
<p>Inline <code>code</code></p>
<p>Indented code</p>
<pre><code>// Some comments
line 1 of code
line 2 of code
line 3 of code
</code></pre>
<p>Block code "fences"</p>
<pre><code>Sample text here...
</code></pre>
<p>Syntax highlighting</p>
<pre><code class="language-js">var foo = function (bar) {
  return bar++;
};

console.log(foo(5));
</code></pre>
<h2 style="color: DarkViolet;">Tables</h2>
<table>
<thead>
<tr>
<th>Option</th>
<th>Description</th>
</tr>
</thead>
<tbody>
<tr>
<td>data</td>
<td>path to data files to supply the data that will be passed into templates.</td>
</tr>
<tr>
<td>engine</td>
<td>engine to be used for processing templates. Handlebars is the default.</td>
</tr>
<tr>
<td>ext</td>
<td>extension to be used for dest files.</td>
</tr>
</tbody>
</table>
<p>Right aligned columns</p>
<table>
<thead>
<tr>
<th align="right">Option</th>
<th align="right">Description</th>
</tr>
</thead>
<tbody>
<tr>
<td align="right">data</td>
<td align="right">path to data files to supply the data that will be passed into templates.</td>
</tr>
<tr>
<td align="right">engine</td>
<td align="right">engine to be used for processing templates. Handlebars is the default.</td>
</tr>
<tr>
<td align="right">ext</td>
<td align="right">extension to be used for dest files.</td>
</tr>
</tbody>
</table>
<h2 style="color: DarkViolet;">Links</h2>
<p><a href="http://dev.nodeca.com">link text</a></p>
<p><a href="http://nodeca.github.io/pica/demo/" title="title text!">link with title</a></p>
<p>Autoconverted link <a href="https://github.com/nodeca/pica">https://github.com/nodeca/pica</a> (enable linkify to see)</p>
<h2 style="color: DarkViolet;">Images</h2>
<p><img src="https://octodex.github.com/images/minion.png" alt="Minion">
<img src="https://octodex.github.com/images/stormtroopocat.jpg" alt="Stormtroopocat" title="The Stormtroopocat"></p>
<p>Like links, Images also have a footnote style syntax</p>
<p><img src="https://octodex.github.com/images/dojocat.jpg" alt="Alt text" title="The Dojocat"></p>
<p>With a reference later in the document defining the URL location:</p>
  </div>
</template>


